import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple, DemoContent, TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Formsy from 'formsy-react';
import { Button, FormControlLabel, TextField, Hidden, MenuItem, Radio, Icon, Checkbox, Typography, IconButton } from 'material-ui';
import ReactTable from "react-table";
import axios from 'axios';
import { bindActionCreators } from 'redux';
import { Tab, Tabs } from 'material-ui';
import AddIcon from '@material-ui/icons/Add';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from 'material-ui/Dialog';
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import $ from "jquery";
import Input, { InputLabel, InputAdornment } from 'material-ui/Input';
import { withAlert } from 'react-alert';
import Loader from "other-components/loader/loader";

const styles = theme => ({
    layoutRoot: {}
});

var id = null;
var nic = null;
var univercityName = null;
var status = null;
var fieldStudy = null;
var degree = null;
var country = null;
var level = null;
var startDate = null;
var endDate = null;
var isActive = null;
;
var emp_profile_id = null;
var emp_registry_id = null;

class Tab6LoadEmployeeHigherEducationDetails extends Component {

    state = {
        canSubmit: false,
        // value :0
    };

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            loading: true,
            data: [],
            value: ''
        };
        this.loadData();


        // this.state = {
        //     imageURL: 'assets/images/default-avatar.png',

        //     value: '',
        //     grade: '',
        //     subject: ''
        // };


    }


    // Edit Statement
    stateEdit = {
        canEdit: false
    };

    handleClickOpenEdit = () => {
        this.setState({ edit: true });
    };

    handleCloseEdit = () => {
        this.setState({ edit: false });
    };

    handleCloseSalary = () => {
        this.setState({ salary: false });
    };


    handleSearchAny = (e) => {
        // alert(e.target.value)
        this.setState({
            value: e.target.value
        });
        this.loadSearchData(e.target.value)
    }

    loadSearchData(searchValue) {

        const searchValueObj = {
            searchval: searchValue
        }
        var data = [];

        // axios.post('http://localhost:5002/hr/searchEmpHigherEducationQulification', searchValueObj)
        axios.post(window.hrmServer+'/hr/searchEmpHigherEducationQulification', searchValueObj)
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var employeeObj = response.data.resultSearch;
                    // console.log("peeen "+employeeObj[31].PROFILE_IMAGE);

                    for (var i = 0; i < employeeObj.length; i++) {

                        data.push({

                            nic: employeeObj[i].NIC,
                            univercityName: employeeObj[i].UNIVERCITY_NAME,
                            degree: employeeObj[i].DEGREE,
                            fieldStudy: employeeObj[i].FIELD_STUDY,
                            country: employeeObj[i].COUNTRY,
                            status: employeeObj[i].STATUS,
                            level: employeeObj[i].LEVEL,
                            startDate: employeeObj[i].START_DATE,
                            endDate: employeeObj[i].END_DATE,
                            emp_profile_id: employeeObj[i].ID_EMPLOYEE_REGISTRY,
                            emp_registry_id: employeeObj[i].ID_EMPLOYEE_PROFILE
                        });
                    }
                    this.setState({ data: data });
                }


            }).catch(function (error) {
                console.log("err " + error);
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });

        this.handleCloseEdit();
    }



    // load all emlployee personal data 
    loadData() {
        // axios.get('http://localhost:5002/hr/getEmployeeHigherEducationQulification')
            axios.get(window.hrmServer+'/hr/getEmployeeHigherEducationQulification')
            .then(response => {
                if (response.data.success) {
                    // alert('Success');
                    var employeeObj = response.data.rows;

                    this.appendToTable(employeeObj);
                }
            });

        this.handleCloseEdit();
    }


    // append data into table
    appendToTable(employeeObj) {
        var data = [];
        // console.log("peeen " + employeeObj[31].PROFILE_IMAGE);

        for (var i = 0; i < employeeObj.length; i++) {


            data.push({
                nic: employeeObj[i].NIC,
                univercityName: employeeObj[i].UNIVERCITY_NAME,
                degree: employeeObj[i].DEGREE,
                fieldStudy: employeeObj[i].FIELD_STUDY,
                country: employeeObj[i].COUNTRY,
                status: employeeObj[i].STATUS,
                level: employeeObj[i].LEVEL,
                startDate: employeeObj[i].START_DATE,
                endDate: employeeObj[i].END_DATE,
                emp_profile_id: employeeObj[i].ID_EMPLOYEE_REGISTRY,
                emp_registry_id: employeeObj[i].ID_EMPLOYEE_PROFILE
            });

        }
        this.setState({ data: data });
        this.setState({ loading: false });
    }




    // edit persanol details function
    editEmployeeAlDetail(model) {

        var deleteObj = {
            employeeNic: model.nic
        }

        // alert(model.degree)

        const employeeEducationDataObj = {
            nic: model.nic,
            emp_profile_id: model.emp_profile_id,
            emp_registry_id: model.emp_registry_id,
            univercityName: model.univercityName,
            fieldStudy: model.fieldStudy,
            degree: model.degree,
            country: model.country,
            level: model.level,
            status: model.status,
            startDate: model.startDate,
            endDate: model.endDate

        }

        // axios.post('http://localhost:5002/hr/deleteEmployeeHigherEducationQualification', deleteObj)
            axios.post(window.hrmServer+'/deleteEmployeeHigherEducationQualification', deleteObj)
            .then(response => {

                if (response.data.success) {
                    // alert('Success');
                    // axios.post('http://localhost:5002/hr/updateEmpHigherEducationQulification', employeeEducationDataObj)
                        axios.post(window.hrmServer+'/updateEmpHigherEducationQulification', employeeEducationDataObj)
                        .then(response => {

                            if (response.data.success) {
                                // alert('Success');
                                this.handleCloseEdit();
                                this.loadData();
                                this.props.alert.success("Employee Higher Education Qulification Updated Successfully");

                            } else {
                                // alert("Delete Faild !");
                                this.props.alert.error("Error In Employee Higher Education Qulification Update");

                            }
                        }).catch(function (error) {
                            // alert("Error");
                            console.log("No internet connection or Internal error");
                            // alert("No internet connection or Internal error");
                        });

                } else {

                }
            }).catch(function (error) {
                // alert("Error");
                console.log("No internet connection or Internal error");
                // alert("No internet connection or Internal error");
            });
    }
    // Add Statement

    addhandleClickOpen = () => {
        this.setState({ add: true });
    };

    addhandleClose = () => {
        this.setState({ add: false });
    };

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    // edit employee personal details
    onEdit = (model) => {

        this.editEmployeeAlDetail(model);
    };

    disableButtonDelete = () => {
        this.setState({ canEdit: false });
    };

    enableButtonDelete = () => {
        this.setState({ canEdit: true });
    };

    handleClickSalary = () => {
        this.setState({ salary: true });
    };


    // Delete Statement
    handleClickDelete = () => {
        this.setState({ delete: true });
    };

    handleCloseDelete = () => {
        this.setState({ delete: false });
    };

    stateDelete = {
        canDelete: false
    };

    onDelete = (model) => {
        this.deleteEmployeeAlDetail(model);
    };

    // delete emplpoyee personal details
    deleteEmployeeAlDetail(model) {

        var employeeNic = model.nic;

        if (null == employeeNic || "" == employeeNic || undefined == employeeNic) {
            // alert("Cannot Delete this Employee");
        } else {

            var deleteObj = {
                employeeNic: employeeNic
            }

            // axios.post('http://localhost:5002/hr/deleteEmployeeHigherEducationQualification', deleteObj)
                axios.post(window.hrmServer+'/hr/deleteEmployeeHigherEducationQualification', deleteObj)
                .then(response => {

                    if (response.data.success) {
                        // alert('Success');
                        this.handleCloseDelete();
                        this.loadData();
                        this.props.alert.success("Employee Higher Education Qulification Deleted Successfully");
                    } else {
                        // alert("Delete Faild !");
                        this.props.alert.error("Error In Employee Higher Education Qulification Delete");
                    }
                }).catch(function (error) {
                    // alert("Error");
                    console.log("No internet connection or Internal error");
                    // alert("No internet connection or Internal error");
                });
        }
    }


    render() {
        const { classes, openEditContactDialog } = this.props;
        const { canSubmit } = this.state;
        const { canEdit } = this.stateEdit;
        const { canDelete } = this.stateDelete;
        const { value } = this.state;

        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (

                <div className="w-full">

                    <div className="flex flex-wrap -mx-3 mb-12">
                        <div className="w-full md:w-2/3"></div>
                        <div className="w-full md:w-1/3">
                            {/* <Icon className="-mb-32 -mr-16" color="action">search</Icon> */}
                            <TextField
                                placeholder="Search for anything"
                                className="pl-16"
                                fullWidth
                                value={this.state.value}
                                inputProps={{
                                    'aria-label': 'Search'
                                }}
                                onChange={this.handleSearchAny}
                            />
                        </div>
                    </div>
                    <ReactTable className="w-full"
                        getTrProps={(state, rowInfo, column) => {
                            return {
                                className: "cursor-pointer",
                                onClick: (e, handleOriginal) => {

                                }
                            }
                        }}
                        data={this.state.data}
                        columns={[

                            {
                                Header: "Nic",
                                accessor: "nic",
                                // show: false
                            },
                            {
                                Header: "Univercity Name",
                                accessor: "univercityName",
                                // show: false
                            },

                            {
                                Header: "Degree",
                                accessor: "degree",
                                // show: false
                            },
                            {
                                Header: "Field Study",
                                accessor: "fieldStudy"

                            },
                            {
                                Header: "Country",
                                accessor: "country"

                            },
                            {
                                Header: "Status",
                                accessor: "status"

                            },



                            {
                                Header: "Action",
                                // accessor: "su",
                                width: 128,
                                Cell: row => (
                                    <div className="flex items-center w-8 h-8">
                                        <IconButton

                                            onClick={(e) => {
                                                if (row) {

                                                    univercityName = row.original.univercityName;
                                                    degree = row.original.degree;
                                                    nic = row.original.nic;
                                                    fieldStudy = row.original.fieldStudy;
                                                    country = row.original.country;
                                                    status = row.original.status;
                                                    level = row.original.level;
                                                    startDate = row.original.startDate;
                                                    endDate = row.original.endDate;
                                                    emp_profile_id = row.original.emp_profile_id;
                                                    emp_registry_id = row.original.emp_registry_id;
                                                    this.setState({ edit: true });
                                                }
                                            }}

                                        >
                                            <Icon className="text-blue">mode_edit</Icon>
                                        </IconButton>

                                        {/* ///// */}

                                        <Dialog

                                            open={this.state.edit}
                                            onClose={this.handleCloseEdit}
                                            aria-labelledby="form-dialog-title"
                                        >
                                            <Formsy
                                                onValidSubmit={this.onEdit}
                                                onValid={this.enableButtonEdit}
                                                onInvalid={this.disableButtonEdit}
                                                ref={(form) => this.form = form}
                                                className=""
                                            >
                                                <DialogTitle id="form-dialog-title">Edit Higher Education Qualification Details</DialogTitle>
                                                <DialogContent className="flex flex-wrap">

                                                    <div className="w-full">

                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="id"
                                                        // value={id}
                                                        />
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="emp_profile_id"
                                                            value={emp_profile_id}
                                                        />
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="emp_registry_id"
                                                            value={emp_registry_id}
                                                        />
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="level"
                                                            value={level}
                                                        />

                                                    </div>

                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="nic"
                                                            label="NIC No"
                                                            value={nic}
                                                            required
                                                            disabled={true}
                                                        />
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="univercityName"
                                                            label="Univercity Name"
                                                            value={univercityName}
                                                        // disabled={true}

                                                        />
                                                    </div>

                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="fieldStudy"
                                                            label="Field Study"
                                                            value={fieldStudy}
                                                        // required
                                                        // disabled={true}
                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/2 mt-16"
                                                            type="text"
                                                            name="country"
                                                            label="Country"
                                                            value={country}

                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="degree"
                                                            label="Degree"
                                                            value={degree}
                                                        // disabled={true}

                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="status"
                                                            label="Status"
                                                            value={status}
                                                        // disabled={true}

                                                        />
                                                    </div>
                                                    <div className="w-full">
                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="date"
                                                            name="startDate"
                                                            label="Start Date"
                                                            value={startDate}
                                                        // disabled={true}

                                                        />

                                                        <TextFieldFormsy
                                                            className="w-1/2 pr-8 mt-16"
                                                            type="text"
                                                            name="endDate"
                                                            label="End Date"
                                                            value={endDate}
                                                        // disabled={true}

                                                        />
                                                    </div>

                                                </DialogContent>
                                                <DialogActions>
                                                    <Button type="button" onClick={this.handleCloseEdit} variant="raised" size="small" color="primary" className="{classes.button} w-full  md:h-24">
                                                        Close
                                                    </Button>

                                                    <Button type="submit" variant="raised" size="small" color="secondary" className="{classes.button} w-full md:h-24 ">
                                                        Update
                                                    </Button>
                                                </DialogActions>
                                            </Formsy>
                                        </Dialog>




                                        <IconButton
                                            onClick={(e) => {
                                                if (row) {

                                                    nic = row.original.nic;
                                                    // deleteFirstName = row.original.firstName;
                                                    // deleteLastName = row.original.lastName;
                                                    this.setState({ delete: true });
                                                }
                                            }}
                                        >
                                            <Icon className="text-red-light">delete</Icon>
                                        </IconButton>


                                        {/* ///// */}

                                        <Dialog
                                            open={this.state.delete}
                                            onClose={this.handleClose}
                                            aria-labelledby="form-dialog-title"
                                        >
                                            <DialogTitle id="form-dialog-title">Delete Higher Education Qualification</DialogTitle>
                                            <DialogContent>

                                                <div>

                                                    <Formsy
                                                        onValidSubmit={this.onDelete}
                                                        onValid={this.enableButtonDelete}
                                                        onInvalid={this.disableButtonDelete}
                                                        ref={(form) => this.form = form}
                                                        className="flex flex-col justify-center"
                                                    >
                                                        <TextFieldFormsy
                                                            type="hidden"
                                                            name="nic"
                                                            value={nic}
                                                        />

                                                        <DialogActions>
                                                            <Button onClick={this.handleCloseDelete} color="primary">
                                                                Cancel
                                                            </Button>

                                                            <Button
                                                                type="submit"
                                                                variant="raised"
                                                                color="primary"
                                                                className="mx-auto mt-16 pb-15"
                                                                aria-label="Edit"
                                                            // disabled={!canEdit}
                                                            >
                                                                Delete
                                                            </Button>
                                                        </DialogActions>
                                                    </Formsy>
                                                </div>
                                            </DialogContent>


                                        </Dialog>




                                        {/* ///// */}


                                    </div>
                                )
                            }

                        ]}
                        defaultPageSize={10}
                        className="-striped -highlight"
                    />

                </div>
            );
        }
    }
}

export default withStyles(styles, { withTheme: true })(withAlert(Tab6LoadEmployeeHigherEducationDetails));


// WEBPACK FOOTER //
// ./src/main/content/hr/viewEmployee/components/Tab6LoadEmployeeHigherEducationDetails.js